import { defineMessages } from 'react-intl';

export default defineMessages({
    propertyScheduledCoverages: {
        id: 'wmic.pe-capability-quoteandbind-common-react.pages.scheduled-coverages.property-scheduled-coverages.section-title',
        defaultMessage: 'Property Scheduled Coverages'
    },
});
